import { call, put, select } from 'redux-saga/effects';
import axios from 'axios';

import {
	messageActions,
	generalActions,
	generalSelectors,
	userSelectors,
} from 'Ducks';
import storeContainer from 'Config/redux/store';
import { SAGA_REQUEST_KEY } from 'Constants';

export function* sagaCallService(service, action, params = {}) {
	const currentStore = storeContainer.store.getState();
	const user = yield select((store) =>
		getRequestUserSessionSelector(params, store)
	);
	const loadingName =
		action.type + `${params?.[SAGA_REQUEST_KEY.LOADING_ID] || ''}`;

	if (!generalSelectors.selectApiLoadingStatus(currentStore, loadingName)) {
		const config = getRequestConfig(service, action, params, user);
		yield put(generalActions.startApiLoading(loadingName));
		let response = yield call(axios, config);
		yield put(generalActions.stopApiLoading(loadingName));

		// if (process.env.NODE_ENV === 'development')
		// 	console.log(`api request result :`, config, response);

		return response;
	}
}

export function* sagaErrorDispatcher(e, action, callbackAction, isArrayMsg) {
	console.error('api request error =>', e?.response || e, action);
	let errorMessage = e?.response?.data?.message || e?.response?.data?.msg;
	errorMessage =
		typeof errorMessage === 'string'
			? errorMessage
			: isArrayMsg === true
			? errorMessage[0]
			: 'عملیات با خطا مواجه شد';

	let disableToast = action?.payload?.[SAGA_REQUEST_KEY.DISABLE_TOAST];

	yield put(generalActions.stopApiLoading(action.type));
	!disableToast &&
		(yield put(
			messageActions.pushErrorToast({
				title: errorMessage,
				toastTime: action.toastTime,
			})
		));
	if (callbackAction) yield put(callbackAction(e));
}

const getRequestConfig = (service, action, params, user) => {
	const config = {
		timeout: 10000,
		headers: {
			'Content-Type': 'application/json',
			Accept: 'application/json',
		},
		...service(params),
	};

	if (action.withAuth) {
		config.headers['X-User-Email'] = user?.email;
		config.headers['X-User-Token'] = user?.authentication_token;
	}

	return config;
};

const getRequestUserSessionSelector = (payload, store) => {
	if (payload?.[SAGA_REQUEST_KEY.SUPER_USER]) {
		let users = userSelectors.selectAllUsers(store);
		return users ? users[0] : userSelectors.selectSession(store);
	} else {
		return userSelectors.selectSession(store);
	}
};
